import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Flags } from 'src/app/components/shared/types/flags.type';
import { MuComponent } from 'src/app/components/shared/types/MuComponent.componetent';
import { ProcessingData } from 'src/app/components/shared/types/processingData.type';
import { MassiveProgramFlags } from './massive-program.flags';

@Component({
  selector: 'app-massive-program',
  templateUrl: './program.component.html',
  styleUrls: ['./program.component.sass'],
})
export class ProgramComponent extends MuComponent {
  flags = new Flags<MassiveProgramFlags>();
  requestId: number;

  /**
   * Loading excel info
   */
  processingServices: ProcessingData<MassiveProgramFlags>;

  /**
   * updating route info
   */
  processingUpdateRouteOrder: ProcessingData<MassiveProgramFlags>;

  constructor(route: ActivatedRoute) {
    super();
    this.watch(route.params).subscribe(params => {
      const rId = params.requestId as string;
      this.requestId = parseInt(rId, 10);
    });
  }

  muOnInit(): void {
    this.processingServices = new ProcessingData<MassiveProgramFlags>({
      flags: this.flags,
      errorFlag: MassiveProgramFlags.SERVICE_FAIL,
      showFlag: MassiveProgramFlags.CREATING_SERVICE,
      title: 'context.massive.creatingServices.title',
      message: 'context.massive.creatingServices.message',
      errorTitle: 'context.massive.creatingServices.errorTitle',
    });
    this.processingUpdateRouteOrder = new ProcessingData<MassiveProgramFlags>({
      flags: this.flags,
      errorFlag: MassiveProgramFlags.UPDATE_ROUTE_ORDER_FAIL,
      showFlag: MassiveProgramFlags.UPDATE_ROUTE_ORDER,
      title: 'context.massive.updateRouteOrder.title',
      message: 'context.massive.updateRouteOrder.message',
      errorTitle: 'context.massive.updateRouteOrder.errorTitle',
    });
  }

  muOnDestroy() {
    /** */
  }
}
